<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />

    <b-row>
      <b-col
        cols="12"
        sm="6"
      >
        <router-link :to="{name: 'rad.pending-approvals'}">
          <iq-card>
            <template v-slot:body>
              <div class="d-flex d-flex align-items-center justify-content-between">
                <div>
                  <h2>{{ pending_approval }}</h2>
                  <p class="fontsize-sm m-0">
                    Pending Approval(s)
                  </p>
                </div>
                <div class="rounded-circle iq-card-icon  dark-icon-light iq-bg-success">
                  <i class="ri-inbox-fill" /></div>
              </div>
            </template>
          </iq-card>
        </router-link>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { RADDashboardService } from '@/services'

export default {
  name: 'RADDashboard',

  middleware: ['auth', 'rad'],

  metaInfo () {
    return {
      title: 'Dashboard'
    }
  },

  data () {
    return {
      pending_approval: 0
    }
  },

  mounted () {
    core.index()
    this.fetchData()
  },

  methods: {
    async fetchData () {
      await RADDashboardService.get().then(({ data }) => {
        this.pending_approval = data.pending_approval
      })
    }
  }
}
</script>
